<template>
  <button
    class="overflow-hidden text-left bg-mbzuai-navy-500 hover:bg-mbzuai-dark-navy transition-colors after:transition-all duration-300 ease-in-out w-full lg:w-auto flex flex-row gap-6 md:justify-center items-center p-6 hover:cursor-pointer after:content-[''] relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-0 after:bg-mbzuai-sand-500 hover:after:h-2"
    @click="handleSelectedTopic"
  >
    <h5 class="text-h5 text-white!" v-if="topic?.topicCopy?.sectionHeading">
      {{ topic?.topicCopy?.sectionHeading || '' }}
    </h5>
  </button>
</template>

<script setup lang="ts">
import type { AiTopic, ImageComponent } from '~/types';

const emit = defineEmits(['selected-topic']);

const { topic } = defineProps<{
  topic: AiTopic;
}>();

const onSelectedTopic = inject<
  | ((payload: { topic: AiTopic; topicImage: ImageComponent['image'] }) => void)
  | null
>('onSelectedTopic');

const handleSelectedTopic = () => {
  const payload = {
    topic: topic,
    topicImage: topic?.topicImage?.image,
  };
  emit('selected-topic', payload);
  onSelectedTopic?.(payload);
};
</script>
